<template>
  <div class="panel">
    <div class="panel-heading d-flex justify-content-between">
      <div class="h3">{{title}}</div>
      <slot name="header"></slot>
    </div>
    <div class="panel-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: { title: { type: String } },
}
</script>

<style>
.h3 {
  font-size: 1rem;
  font-weight: bolder;
}
.panel {
  padding: 1rem 2rem;
  margin-bottom: 1.5rem;
  background: #fff;
  border-radius: 5px;
}
</style>